var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 0.666664H9.99996V4H18V0.666664H27.3333V10H24V18H27.3333V27.3333H18V24H9.99996V27.3333H0.666626V18H3.99996V10H0.666626V0.666664ZM7.33329 7.33333V3.33333H3.33329V7.33333H7.33329ZM6.66663 10V18H9.99996V21.3333H18V18H21.3333V10H18V6.66666H9.99996V10H6.66663ZM20.6666 20.6667V24.6667H24.6666V20.6667H20.6666ZM7.33329 20.6667H3.33329V24.6667H7.33329V20.6667ZM20.6666 3.33333V7.33333H24.6666V3.33333H20.6666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockchain);
export default __webpack_public_path__ + "static/media/icon_blockchain.17aa6e78fa658d3f0aaa5fdb39435a41.svg";
export { ForwardRef as ReactComponent };